import React, { memo, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import { Profile } from '../components';
import { mapGroupStates } from '../modules/Global';

const MapGroupParticipantsComponent = memo(() => {
  const {
    CurrentMap: { ori },
  } = window.Gdata;
  const map = ori[0];
  const showAddButton = map && map.account_id === ori[0].session_account_id;
  const [mapGroups, setMapGroupsState] = useState(map.mapGroups || []);
  mapGroupStates.mapGroupParticipants = setMapGroupsState;
// 首閉め
return null;
  if (typeof map.share_id === 'undefined' || map.share_id != 'open') {
    return null;
  }
  return (
    <ContainerDiv>
      {mapGroups.map(({ nickname, icon_url, accepted }, index) => {
        if (accepted === '0') {
          return null;
        }

        return (
          <Profile
            key={index}
            iconSize={40}
            imageId={icon_url}
            style={{ marginRight: -5 }}
            title={nickname}
          />
        );
      })}
      {showAddButton && (
        <OpenDiv
          onClick={() => window.openMapGroupParticipantsModalComponent()}
        >
          <div>
            <div />
            <div />
          </div>
          <p>{window.resolveLang('共有する...')}</p>
        </OpenDiv>
      )}
    </ContainerDiv>
  );
});

window.renderMapGroupParticipants = () => {
  if (
    window.Gdata.CurrentMap.ori[0].template_id ===
      window.MapClass.template.aliasMap &&
    window.location.host !== 'maplife.icd-vietnam.com'
  ) {
    return;
  }

  ReactDOM.render(
    <MapGroupParticipantsComponent />,
    document.getElementById('mapGroupParticipants')
  );
};

//#region styles
const ContainerDiv = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > * {
    margin-top: 2px;
    margin-bottom: 2px;
  }
`;
const OpenDiv = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;

  & > div {
    width: 40px;
    height: 40px;
    padding: 10px;
    background: #aaa;
    border-radius: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    & > div {
      background: white;

      &:first-child {
        width: 100%;
        height: 4px;
      }

      &:last-child {
        position: absolute;
        width: 4px;
        height: calc(100% - 20px);
        left: calc(50% - 2px);
      }
    }
  }

  & > p {
    padding-left: 8px;
    color: #999;
  }
`;
//#endregion
